import React, { Component } from 'react';

export const CartContext = React.createContext();
export const GlobalSearchContext = React.createContext();